<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds"
>
  @if (loading()) {
    <div
      class="absolute top-0 left-0 flex h-full w-full items-center justify-center bg-black/20 z-20"
    >
      <flx-spinner [size]="'small'"></flx-spinner>
    </div>
  }

  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ title }}
  </div>

  <div
    [formGroup]="duplicateResourceFG"
    (submitForm)="submitModal()"
    class="flx-modal-body"
    flxEnterSubmitForm
  >
    <flx-input class="flx-ds">
      <flx-label class="flx-ds mandatory">{{ resourceType }} Name</flx-label>
      <input
        [formControl]="nameFC"
        placeholder="Enter resource name"
        data-testId="duplicate-resource-name-input"
        flxAutofocus
        flxInput
      />
      @if (nameFC.touched && nameFC.errors?.required) {
        <flx-error data-testId="name-required-error">Name is required</flx-error>
      }
    </flx-input>
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="duplicate-resource-cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        [disabled]="duplicateResourceFG.invalid"
        (click)="submitModal()"
        class="flx-ds primary"
        data-testId="duplicate-resource-create-button"
        flxButton
        type="button"
      >
        Duplicate
      </button>
    </div>
  </div>
</flx-modal>
